var _circle, _circle2, _line, _line2, _line3, _line4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCurrentLocation({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9.99944,
    cy: 10.0002,
    r: 7.21429,
    stroke: "var(--hig-color-primary)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 9.99888,
    cy: 10.0006,
    r: 1.42857,
    stroke: "var(--hig-color-primary)"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 10.0176,
    y1: 0.357422,
    x2: 10.0176,
    y2: 3.25028,
    stroke: "var(--hig-color-primary)"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 10.0176,
    y1: 16.75,
    x2: 10.0176,
    y2: 19.6429,
    stroke: "var(--hig-color-primary)"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 3.24805,
    y1: 10.0178,
    x2: 0.35519,
    y2: 10.0178,
    stroke: "var(--hig-color-primary)"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 19.6426,
    y1: 10.0178,
    x2: 16.7497,
    y2: 10.0178,
    stroke: "var(--hig-color-primary)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCurrentLocation);
export default __webpack_public_path__ + "static/media/current-location.32d6b857.svg";
export { ForwardRef as ReactComponent };